export function registerError(e: Error): any {
  const rum = window.TeliaRum;
  if (rum != null) {
    rum.sendError(e);
  }
}
